import { CompetencyStatusChip } from "altus-ui-components";

export default CompetencyStatusChip;
